import { render, staticRenderFns } from "./OrderCount.vue?vue&type=template&id=72ca36a8&scoped=true&lang=pug"
import script from "./OrderCount.vue?vue&type=script&lang=js"
export * from "./OrderCount.vue?vue&type=script&lang=js"
import style0 from "./OrderCount.vue?vue&type=style&index=0&id=72ca36a8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca36a8",
  null
  
)

export default component.exports